import React, { useEffect } from 'react';
import lensReservationGuide01 from '../../assets/images/event/lens_reservation_guide/lens_reservation_guide_01.png';
import lensReservationGuide02 from '../../assets/images/event/lens_reservation_guide/lens_reservation_guide_02.png';
import lensReservationGuide03 from '../../assets/images/event/lens_reservation_guide/lens_reservation_guide_03.png';

const LensReservationGuidePage: React.FC = () => {
  useEffect(() => {
    document.title = '렌즈 예약 가이드';
  }, []);
  const guideImages = [
    lensReservationGuide01,
    lensReservationGuide02,
    lensReservationGuide03
  ];

  return (
    <div className="max-w-4xl mx-auto">
      {guideImages.map((imageSrc, index) => (
        <div key={index} className="flex justify-center">
          <img
            src={imageSrc}
            alt={`렌즈 예약 가이드 ${index + 1}`}
            className="max-w-full h-auto"
          />
        </div>
      ))}
    </div>
  );
};

export default LensReservationGuidePage;
